/**
 * 商务代言文案数据（丁工位导码 2026-10-30）：唯一来源 = docs/品牌文案填写表.md（§四 吐槽 / §五 官宣 / §5.1 官宣热评）。
 * 改文案 = 改填写表 → 重跑导码（或按行手同步）；⛔ 只在这里改会让文档与代码漂移。
 * 官宣插值 {品牌名}{title}{玩家名} 渲染时替换（EndorsementSystem.renderAnnounce）；
 * 挚友条仅高奢 6 品牌（friend 键），大使/代言人共用 formal 条。
 * 官宣呈现（2026-10-30 改版，茄子令）：media 微博弹窗（博主名=品牌名）在**确认行程之后、月度执行之前**的决策页弹出，
 * 挂 ANNOUNCE_COMMENTS 的 3 条粉丝热评（2026-10-31 起不分档位）；话题 #…# 已写进文案本体，MediaPanel 渲染时自动高亮。
 */
import { BrandTier } from '../types';
export const WS_MOCK_LINES: readonly string[] = [
    '刚有点名气就去站台微商，这钱赚得是一点都不挑。',
    '上个月还在剧里演女二，这个月在朋友圈卖膏药，落差有点大。',
    '我去查了下那个牌子，官网像套模板做的，她也真敢签。',
    '代言费给得高吧，不然谁会接这种牌子。',
    '前几天还在夸她清高，转头就接了微商，滤镜碎了。',
    '不是不能赚钱，是别什么钱都赚。',
];

export const ANNOUNCE_COPY: Record<string, { formal: string; friend?: string }> = {
    'BRD-WS-01': { formal: '喜报！热烈祝贺@{玩家名}正式签约{品牌名}，出任{title}！美丽事业大计，今日启航！！ #慕妍夫人美丽事业# #{玩家名}慕妍夫人品牌代言人#' },
    'BRD-WS-02': { formal: '后台天天有人问黄金瓶到底好不好，今天终于能把话说满：@{玩家名}出任{品牌名}{title}，她的答案在评论区，姐妹们去翻！ #金黛颜黄金瓶# #{玩家名}金黛颜品牌代言人#' },
    'BRD-WS-03': { formal: '她从镜头前走来，带着东方女子的温婉与坚定；我们于时光中守候，守着一炉古法的老手艺。今日，{品牌名}正式宣布：@{玩家名}出任{title}。宫廷御方，静候知音。 #御颜妃宫廷御方# #{玩家名}御颜妃品牌代言人#' },
    'BRD-WS-04': { formal: '重磅喜讯！@{玩家名}签约{品牌名}，出任{title}！滋补赛道再添顶流，送礼倍有面子！！ #御臻燕滋补有面子# #{玩家名}御臻燕品牌代言人#' },
    'BRD-WS-05': { formal: '小瓶胶原喝了大半年，今天终于能把这话说出口：@{玩家名}就是{品牌名}新的{title}。谁喝谁知道，评论区集合！ #初慕胶原小瓶饮# #{玩家名}初慕胶原品牌代言人#' },
    'BRD-WS-06': { formal: '后台又被问爆了！官宣来了：@{玩家名}正式成为{品牌名}的{title}！专家都在推荐，妈妈们冲就完了，宝宝的第一瓶我们承包！ #婴姿宝妈妈的选择# #{玩家名}婴姿宝品牌代言人#' },
    'BRD-WS-07': { formal: '官宣喜报！@{玩家名}出任{品牌名}{title}！在家就能做医美，黑科技一开，岁月根本追不上你！ #妆颜工坊在家做医美# #{玩家名}妆颜工坊品牌代言人#' },
    'BRD-WS-08': { formal: '捷报！！{品牌名}形象大使花落@{玩家名}！名媛衣橱自此有了掌门人，姐妹们的穿搭模板更新！！ #名媛汇名媛衣橱# #{玩家名}名媛汇品牌代言人#' },
    'BRD-WS-09': { formal: '官宣！@{玩家名}成为{品牌名}{title}！轻的是体重，重的是承诺——这个夏天，一起说到做到！ #纤姿代餐说到做到# #{玩家名}纤姿代餐品牌代言人#' },
    'BRD-CL-01': { formal: '不解释，不迎合，只穿自己的版本。@{玩家名}，{品牌名}{title}——街头见真章。 #ROWD8街头见真章# #{玩家名}ROWD8品牌代言人#' },
    'BRD-CL-02': { formal: '黑白之间，留白给态度。官宣：@{玩家名}出任{品牌名}{title}。 #BLKLAB黑白态度# #{玩家名}BLKLAB品牌代言人#' },
    'BRD-CL-03': { formal: '憋了一整个赛季的秘密：@{玩家名}，{品牌名}{title}。上场前记得来一罐——开盖，犇起来！ #开盖犇上场# #{玩家名}开盖犇品牌代言人#' },
    'BRD-CL-04': { formal: '声音的事，从来不用翻译。{品牌名}官宣：@{玩家名}加入{title}阵容。 #BASSIC听现场# #{玩家名}BASSIC品牌代言人#' },
    'BRD-CL-05': { formal: '新世界开服公告：@{玩家名}正式加入{品牌名}，出任{title}。赛事见，别掉线。 #GGX新世界开服# #{玩家名}GGX品牌代言人#' },
    'BRD-XF-01': { formal: '一色一味，皆有来历。@{玩家名}，{品牌名}{title}——往后一支口红一个典故，由你续写。 #兰芷子一色一味# #{玩家名}兰芷子品牌代言人#' },
    'BRD-XF-02': { formal: '不讲概念，只讲安心。{品牌名}宣布：@{玩家名}成为我们的{title}。欢迎她。 #棉朵家只讲安心# #{玩家名}棉朵家品牌代言人#' },
    'BRD-XF-03': { formal: '零糖零脂的第 365 天，等来了同路人。{品牌名}宣布：@{玩家名}出任{title}。轻盈这件事，交给气泡，也交给她。 #轻汽零糖轻盈# #{玩家名}轻汽品牌代言人#' },
    'BRD-XF-04': { formal: '一盏茶的时间，古今都到了。{品牌名}官宣：@{玩家名}成为我们的{title}。 #拾茶记一盏茶# #{玩家名}拾茶记品牌代言人#' },
    'BRD-XF-05': { formal: '把参数摆上桌的第五年，等到了能一起谈体验的人。{品牌名}宣布：@{玩家名}成为我们的{title}。 #岚声把参数摆上桌# #{玩家名}岚声品牌代言人#' },
    'BRD-XF-06': { formal: '山海经卷不停笔，今日添一位同行者。{品牌名}宣布：@{玩家名}出任{title}。新剧情线，开启。 #山海司新剧情线# #{玩家名}山海司品牌代言人#' },
    'BRD-GM-01': { formal: '三代人的早餐桌，一以贯之的品质。{品牌名}正式宣布：@{玩家名}担任{title}，携手把熟悉的味道送上千家万户的餐桌。 #丰禾三代人的早餐# #{玩家名}丰禾乳业品牌代言人#' },
    'BRD-GM-02': { formal: '山还是那座山，水还是那瓶水。{品牌名}正式宣布：@{玩家名}担任{title}。三十年如一日的坚持，只为每一个清晨的货架第一排——从此，多一位老朋友。 #云岭山泉货架第一排# #{玩家名}云岭山泉品牌代言人#' },
    'BRD-GM-03': { formal: '三十年，家家都有一台。{品牌名}正式宣布：@{玩家名}担任{title}，欢迎新朋友进家门。 #万家家电三十年# #{玩家名}万家家电品牌代言人#' },
    'BRD-GM-04': { formal: '从国民第一辆家用车起步，{品牌名}陪伴千万家庭走过了这些年。今日正式宣布：@{玩家名}担任{title}。家的下一程，我们一起开。 #领航家的下一程# #{玩家名}领航汽车品牌代言人#' },
    'BRD-GM-05': { formal: '{品牌名}创立三十余年，始终陪伴千家万户的日常。今日正式宣布：@{玩家名}出任{title}。洗去一天的风尘，也洗出生活的本色——洗手台上的老朋友，欢迎新面孔。 #洁佳净洗手台上的老朋友# #{玩家名}洁佳净品牌代言人#' },
    'BRD-GS-03': { formal: '始于实验室，成于时间。{品牌名}宣布：@{玩家名}自即日起出任{title}。此后的一切，交给肌肤与时间。 #姈碧交给时间# #{玩家名}姈碧{title}#', friend: '欢迎@{玩家名}加入{品牌名}，出任品牌挚友。本季系列，如期而至。 #姈碧本季系列# #{玩家名}姈碧品牌挚友#' },
    'BRD-GS-06': { formal: '深海巨藻，慢酵一年，方成一瓶。{品牌名}宣布：@{玩家名}自即日起出任{title}。深海的奇迹，从此有了她的名字。 #海清之神深海奇迹# #{玩家名}海清之神{title}#', friend: '{品牌名}与@{玩家名}，品牌挚友。深海之秘，本季揭晓。 #海清之神深海之秘# #{玩家名}海清之神品牌挚友#' },
    'BRD-GS-01': { formal: '时间打磨的，才配得上永恒。{品牌名}宣布：@{玩家名}自即日起出任{title}。橱窗一年只换两次，这一次为新的名字而换。 #斐珞永恒时刻# #{玩家名}斐珞{title}#', friend: '@{玩家名}出任{品牌名}品牌挚友。珍贵时刻，本季见。 #斐珞珍贵时刻# #{玩家名}斐珞品牌挚友#' },
    'BRD-GS-02': { formal: '二十年，九家店，一贯的挑剔。{品牌名}宣布：@{玩家名}自即日起出任{title}。 #奥岚一贯的挑剔# #{玩家名}奥岚{title}#', friend: '{品牌名}：@{玩家名}，品牌挚友。下一场私享会，静候。 #奥岚私享会# #{玩家名}奥岚品牌挚友#' },
    'BRD-GS-04': { formal: '一年只走一场秀，一针一线皆是分寸。值本季高定发布之际，{品牌名}宣布：@{玩家名}自即日起出任{title}。 #索澜一针一线# #{玩家名}索澜{title}#', friend: '{品牌名}挚友名单更新：@{玩家名}。秀场头排，本季为她留座。 #索澜秀场头排# #{玩家名}索澜品牌挚友#' },
    'BRD-GS-05': { formal: '一辆车等一年，等的是懂它的人。{品牌名}宣布：@{玩家名}出任{title}。抵达之前，皆是风景。 #朗瑟抵达之前# #{玩家名}朗瑟{title}#', friend: '{品牌名}欣然宣布：@{玩家名}出任品牌挚友。新季首航，同席以待。 #朗瑟新季首航# #{玩家名}朗瑟品牌挚友#' },
};

/**
 * 官宣微博热评（2026-10-31 茄子令）：不分档位，所有品牌共用 3 条粉丝口吻评论；
 * canonical = 填写表 §5.1。弹窗里固定三行，昵称一律 momo（MediaPanel 口径）。
 * ⚠️ 品牌官微评论区=全是正面（品牌方删负面+粉丝控评），负面只走路人微博 WS_MOCK_LINES。
 */
export const ANNOUNCE_COMMENTS: readonly string[] = [
    '支持代言人{玩家名}',
    '一起get代言人同款！！',
    '恭喜姐姐拿下新代言～',
];
